import styled from "styled-components";


export const Wrapper = styled.div`
  .main-calendar-data {
    background: rgb(58, 150, 184);
    padding: 5px 5px;
    box-shadow: ${props => props.isSmall ? "none" : "0px 0px 15px 1px #00000066"};
    margin-top: ${props => props.isSmall ? "50px" : "120px"};
    margin-left: ${props => props.isSmall ? "0" : "60px"};
    border-radius: 15px;
    height: 45vh;
    width: 40px; /* Adjust the width value to your desired size */
  }

  .heading {
    color: white;
    font-size: ${props => props.isSmall ? "20px" : "23px"};
    margin-top:30px;
    margin-bottom:-10px;
    margin-right: ${props => props.isSmall ? "240px" : "540px"};
    font-weight: bold;

  }

  .background-container {
    position: absolute;
    top: ${props => props.isSmall ? "30px" : "0px"};
    left: ${props => props.isSmall ? "8px" : "0px"};
    right: ${props => props.isSmall ? "12px" : "10px"};
    width: ${props => props.isSmall ? "calc(100vw - 20px)" : "100%"};

    background-color: rgba(0, 0, 0, 0.8); /* Change the opacity value to adjust transparency */
    z-index: -1;
  }
  

  .background-date-container {
      display: flex;
      flex: 1;
      flex-direction: column;
      gap: 20px;
      background-color: rgb(58, 150, 184);
      padding: ${props => props.isSmall ? "10px" : "20px"};
      margin-top:20px;
      position: relative;
      border-radius: 5px;
      height: ${props => props.isSmall ? "20vh" : "25vh"};
      justify-content: ${props => props.isSmall ? "space-evenly" : "space-between"};

     .top-icons{

        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;

          .currentMonth_Div{
            font-size: 16px;
            color: white;
            font-weight: 600;
          }
     }
  }

  .background-appointment-container{
    padding: 45px;
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
    align-items: center;
    margin-left: 55px;
    margin-top:12px;
    width: 600px;
    height: ${props => props.isSmall ? "20vh" : "10vh"};    
    scroll-behavior: smooth;
  }
 
  .background-appointment-container::-webkit-scrollbar{
    display: none;
  }


  .background-appointment-cards{
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    background-color: white;
    color: black;
    border-radius: 10px;
    padding: 30px;
    margin-right: 10px;
    font-size:${props => props.isSmall ? "16px" : "12px"} ;
    font-weight: bold;
    height: ${props => props.isSmall ? "80px" : "38px"};
    width:  ${props => props.isSmall ? "60px" : "auto"};
    flex-shrink: 0;
  }

  .styledbtn1{
    border: 1px solid white;
    border-radius: 80%;
    background-color: white;
    width: 33px;
    height: 30px;
    position: absolute;
    left: 15px;
    top: 40px;
  }
  
  .styledbtn2{
    border: 1px solid white;
    border-radius: 80%;
    background-color: white;
    width: 33px;
    height: 30px;
    position: absolute;
    right: 15px;
    top: 40px;
  }

  .styledBtndate{
    border: 1px solid white;
    border-radius: 80%;
    background-color: white;
    width: 33px;
    height: 30px;
  }

  /* .styledBtndate2{
    border: 1px solid white;
    border-radius: 80%;
    background-color: white;
    width: 33px;
    height: 30px;
    position: absolute;
    right: 5px;
    top: 130px;
  } */
  .date-cards-container {

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    scroll-behavior: smooth;
  }



  .date-cards-container::-webkit-scrollbar{

    display: none;
  }
  
  .date-cards {
    display: flex;
  }
  
  .date-card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    background: white;
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;
  }

  .renderDataCard{
    display: flex;
    gap: 10px;
    align-items: center;
    overflow-x: auto;
    white-space: nowrap;
    overflow: hidden;
  }

  .test {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;
    height: 2vh;
    margin-bottom: ${props => (props.isSmall ? "10px" : "50px")};
    padding: 0px 10px;
  }
  
  .month-year {
    color: white;
    font-size: ${props => (props.isSmall ? "20px" : "24px")};
    font-weight: bold;
    white-space: nowrap;
    margin-bottom: 90px;
    margin-right: ${props => (props.isSmall ? "205px" : "370px")};
  }
  
  .calendar-icon {
    font-size: ${props => (props.isSmall ? "24px" : "36px")};
    color: white;
    margin-bottom: 90px;
    margin-right: 0px;
    cursor: pointer;
   
  }
  
  
  
  
  .day {
    margin-bottom: 4px;
  }
  
  .date {
    font-size: 24px;
  }
  
  .date-card.selected {
    background-color: black;
    color: white;
  }
  
  
  .popup {
    position: fixed;
    top: ${props => props.isSmall ? "61%" : "60%"};
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: rgb(19, 31, 40);
    width: ${props => props.isSmall ? "390px" : "750px"};
    height: ${props => props.isSmall ? "600px" : "750px"};
    z-index: 9999;
    padding:20px;
    /* Add any additional styling you want */
  }

  .close-icon {
    color: white;
    font-size: 20px; /* Increase the font size as desired */
    position: absolute;
    top: 10px; /* Adjust the top position as needed */
    right: 10px; /* Adjust the right position as needed */
    cursor: pointer;
  }
  
  .timing.selected {
    background-color: black;
    color: white;
  }
  
  .appoinment-list-container {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 10px;
    
    .appoinment-Card-List {
      background: white;
      padding: 8px;
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;
      
      .apt-date {
        font-size: 14px;
      }

      .apt-summary {
        font-size: 14px;
        font-weight: 600;
      }
    }
  }

  
  /* .time-data {
    background: #3a96b8;
    padding: 20px 30px;
    box-shadow: 0px 0px 15px 1px #00000066;
    position: relative;
    left: 10px;
    border-radius: 10px;
    overflow: auto;
    top:20px;
   
  } */

  .time-data::-webkit-scrollbar-track {
    background-color: #3a96b8;
    border-radius: 15px;

  }
  
  .time-data::-webkit-scrollbar {
    width: 12px;
    background-color: #f5f5f5;
    border-radius: 15px;

  }
  
  .time-data::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #3a96b8;
  }

  .buttons {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    margin-top: 50px;
  }

  .select {
    text-align: left;
  }

  .ant-select-selector {
    font-size: 18px;
    color: #2c3e50;
    height: 50px !important;
    align-items: center !important;
    overflow: hidden !important;
  }

  .ant-select-selection-item {
    overflow: initial !important;
  }

  .ant-select-single .ant-select-selector .ant-select-selection-item {
    line-height: 4px !important;
  }

  .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
    line-height: 30px !important;
  }

  .ant-select-selection-placeholder {
    color: #2c3e50;
  }

  .ant-select-item .ant-select-item-option {
    font-size: 12px;
    color: #2c3e50;
  }

  .anticon-spin {
    font-size: 24px;
    color: #fff;
    width: 100%;
  }

  .react-calendar__navigation {
    padding: 10px 0px;

    span {
      font-size: 20px;
      padding: 10px;
    }

    .label {
      border: 2px solid #3a96b8;
      border-radius: 50%;
    }

    button {
      text-transform: none;
      background: #131f28;
      color: #fff;
      padding: 5px 18px;
      border: none;
    }

    .react-calendar__navigation__next2-button:hover,
    .react-calendar__navigation__next-button:hover,
    .react-calendar__navigation__prev-button:hover,
    .react-calendar__navigation__prev2-button:hover {
      background-color: #3a96b8;
      border-radius: 10px;
    }

    span:hover {
      cursor: pointer;
      background-color: #3a96b8;
      border-radius: 10px;
      padding: 10px;
    }
  }

  .react-calendar__viewContainer {
    button {
      text-transform: none;
      background: transparent;
      color: #fff;
      padding: 5px 5px;
      border: none;
    }

    button:focus,
    button:hover {
      cursor: pointer;
      background-color: black;
      border-radius: 10px;
    }

    .react-calendar__month-view__weekdays {
      
      background-color: white;
      padding: 5px 5px;
      border-radius: 7px;
      margin-top: 40px;
      margin-bottom: 30px;
      text-decoration: none !important;
    }

  }

  .react-calendar__navigation__arrow {
    font-size: 20px;
  }

  .react-calendar__month-view__days {
    margin: 0px;
  
  }

  .react-calendar__month-view__weekdays__weekday:hover {
    cursor: pointer;
    background-color: #3a96b8;
    border-radius: 8px;
    text-decoration: none !important;
  }

  .show-time-data{
    border-radius: 5px;
      padding: 5px;
      font-size: 14px;
      cursor: pointer;
      
  }

  .show-time-data-active{
    border-radius: 5px;
      padding: 5px;
      font-size: 14px;
      font-weight: bold;
      background-color: white;
      cursor: pointer;
  }

  .show-time-data:hover{
      background-color: #fffffff3;
     
  }

/* 
  .show-time-data {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    font-size:10px;
    border-radius: 10px;

    h6 {
      margin: 0px;
      color: #fff;
      cursor: pointer;
    }
  } */

  /* .show-time-data:focus,
  .show-time-data:hover {
    cursor: pointer;
    border: 2px solid #3a96b8;
    background-color: rgb(19, 31, 40);
    border-radius: 10px;
    h6 {
      color: white;
    }
  }

  .show-time-data-active {
    background-color: rgb(19, 31, 40);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3px 10px;
    border: 2px solid transparent;

    h6 {
      margin: 0px;
      color: #3a96b8;
      cursor: pointer;
    }
  } */

  .react-calendar__tile--active {
    cursor: pointer;
    background-color: #3a96b8 !important;
    color: #fff !important;
    border-radius: 10px;
  }

  .react-calendar__tile:disabled {
    background: lightblue;
    cursor: no-drop;
    color: black;
    border-radius: 50%;
  }

  .react-calendar__tile:disabled:hover {
    background: #d3d3d357;
    border-radius: 50%;
    cursor: no-drop;
  }

  @media screen and (max-width: 991px) {
    /* .time-data {
      background: #3a96b8;
      padding: 20px 30px;
      box-shadow: 0px 0px 15px 1px #00000066;
      position: relative;
      left: 0px !important;
      border-radius: 15px;
      height:170px;
    } */
  }

    .time-data {
            background: #3a96b8;
          margin-top: 20px;
          border-radius: 5px;
          height: ${props => props.isSmall ? "20vh" : "30vh"};
          padding: 10px;
          overflow-y: auto;
          white-space: nowrap;
    }

  @media screen and (max-width: 500px) {
    .react-calendar__viewContainer button {
      padding: 5px 6px !important;
    }

    .react-calendar__navigation button {
      padding: 5px 3px !important;
    }

    .ant-row {
      padding: 0px 14px;
    }

    .main-calendar-data {
      padding: 25px 30px !important;
      height:50vh;
    }

        

/* 
    .show-time-data {
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 3px 10px; 
      border: 2px solid transparent;
      font-size: 24px; 
    
      h6 {
        margin: 0px;
        color: #fff;
        cursor: pointer;
      }
    } */
    
  }

  /* .show-time-data-active {
    background-color: rgb(19, 31, 40);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3px 10px;
    border: 2px solid transparent;

    h6 {
      margin: 0px;
      color: #3a96b8;
      cursor: pointer;
    }
  } */
`;
